(function ($) {
    jQuery(document).ready(function () {
        const sizes = ['smaller', 'normal', 'larger'];
        let currentSize = localStorage.getItem('font-size') || 'normal';
        $('.accessibility-font-sizer .font-size-' + currentSize).addClass('active');
        $('html').addClass('accessibility-font-size-' + currentSize);

        $('.accessibility-font-sizer').on('click', function () {
            $('.accessibility-font-sizer .font-size-' + currentSize).removeClass('active');
            $('html').removeClass('accessibility-font-size-' + currentSize);

            currentSize = sizes[(sizes.indexOf(currentSize) + 1) % sizes.length];
            localStorage.setItem('font-size', currentSize);
            $('.accessibility-font-sizer .font-size-' + currentSize).addClass('active');
            $('html').addClass('accessibility-font-size-' + currentSize);
        });
    });
})(jQuery);
